// IMAGES
export const IMG_TO_ATTACH = 'adjuntar.svg';
export const CL_FLAG = 'cl.svg';
export const AR_FLAG = 'ar.svg';
export const FPAY_LOGO = 'logo-fpay';
export const BACKGROUND_FPAY_BLUE = 'background-fpay-blue';
export const BACKGROUND_FPAY_GREEN = 'background-fpay-green';
export const BACKGROUND_FPAY_ROSE = 'background-fpay-rose';
export const ARROW_RIGHT = 'arrow-right';
export const LEFT_ARROW = 'left-arrow';
export const SATISFACTORY_ANSWER_HAND = 'satisfactory-answer-hand';
export const FAILED_ANSWER_HAND = 'failed-answer-hand';
export const APPLE_APP_STORE = 'apple-app-store';
export const GOOGLE_PLAY_STORE = 'google-play-store';
export const SCANN_AND_DOWNLOAD = 'scann-and-download';
export const SAD_FACE = 'sad-face';
export const CRYING_FACE = 'crying-face';
